import moment from "moment-timezone";
import _ from "lodash";

/**
 * @typedef {{start: string, end: string, label: string}} Timestamp
 * @typedef {{name: string, data: number[]}} LineChartDatum
 * @typedef {{createdAt: string, response: string}} LineChartData
 * @property {LineChartDatum[]} series
 * @property {string[]} labels
 */

/**
 * Get the data for line charts displaying invitation activity over time.
 * @param {ProjectMetricInvitationItem[]} invitations
 * @param {Timestamp[]} timestamps
 * @returns {LineChartData}
 */
export default function getQuestionActivityChartData(invitations, timestamps) {
  const normalizedInvitations = invitations.map(project => ({
    ...project,
    createdAt: moment(project.createdAt),
  }))

  const seriesData = _.map(timestamps, ({ start, end, label }) => {
    const startMoment = moment(start);
    const endMoment = moment(end);

    const counts = _.transform(
      normalizedInvitations,
      (acc, invitation) => {
        const { createdAt } = invitation;

        if (createdAt.isBetween(startMoment, endMoment, null, "[]")) {
          acc.sent++;
          if (invitation.response === 'Connect') acc.connected++;
          if (invitation.response === 'Pending') acc.pending++;
          if (invitation.response === 'Decline') acc.declined++;
        }
      },
      { sent: 0, connected: 0, pending: 0, declined: 0 }
    );

    return { label, counts };
  })

  return {
    series: [
      {
        name: 'Sent',
        data: seriesData.map(d => d.counts.sent)
      },
      {
        name: 'Connected',
        data: seriesData.map(d => d.counts.connected)
      },
      {
        name: 'Pending',
        data: seriesData.map(d => d.counts.pending)
      },
      {
        name: 'Declined',
        data: seriesData.map(d => d.counts.declined)
      }
    ],
    labels: seriesData.map(d => d.label)
  }
}
